import { useEffect, useState } from 'react';
import Buttons from '../../../components/button/Buttons';
import TextWinds from '../../../components/common/TextWinds';
import NormalPage from '../../../components/layout/NormalPage';
import CustomDialog from '../../../components/layout/CustomDialog';
import MyClassCard from './component/MyClassCard';
import FullDialog from '../../../components/layout/FullDialog';
import Box from '../../../components/layout/Box';
import PageHead from '../../../components/layout/PageHead';
import instance from '../../../api/axios/utils.ts/instance';
import { useAppDispatch } from '../../../store/hook';
import { openModal } from '../../../store/features/modalSlice';
import ModalExtendLink from '../../../components/modal/ModalExtendLink';

const ClassManagement = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState([]);
  const handleExtend = (courseId: string) => {
    dispatch(
      openModal({
        body: <ModalExtendLink courseId={courseId} />,
      }),
    );
  };

  useEffect(() => {
    // API 호출 함수
    const fetchData = async () => {
      try {
        const response = await instance.get('/v1/my-class');
        const res = response.data;
        setData(res.data);
      } catch (error) {}
    };

    fetchData(); // 데이터 가져오기 함수 호출
  }, []);

  return (
    <NormalPage>
      <PageHead>
        <TextWinds type="title_h2" xlType="title_h1">
          클래스 관리
        </TextWinds>
      </PageHead>
      <Box>
        {data.length > 0 ? (
          data.map((item, index) => (
            <MyClassCard
              key={index}
              data={item.myClass}
              linkTo={`/lms/${item.myClass.id}/dashboard`}
              openExtend={() => handleExtend(item.course.id)}
            />
          ))
        ) : (
          <div className="flex w-full flex-col">
            <TextWinds type="title_h2" className="mt-3 w-full text-center">
              아직 개설된 클래스가 없습니다.
            </TextWinds>
            <br />
            <TextWinds type="title_h2" className="w-full text-center">
              코스를 수료하신 후 클래스를 이용하세요.
            </TextWinds>
          </div>
        )}
      </Box>
      {/* <div className="mt-[64px] xl:absolute xl:top-[18px] xl:w-[177px] xl:right-[50%] xl:mt-0 xl:translate-x-2/4 xl:mr-[-498px]">
            <Buttons type="outlined" color="purple5">
                내 학습 이용 메뉴얼
            </Buttons>
        </div> */}
    </NormalPage>
  );
};

export default ClassManagement;
